module.exports = "<div ng-class=vm.stateContext> <i class=\"ico ico-w-1\" ng-class=vm.stateIcon></i> <span class=type-small>{{ vm.state.name }}</span> </div>";


//////////////////
// WEBPACK FOOTER
// ./features/account/parcels/components/parcel-line-state.html
// module id = 551
// module chunks = 0